import axios from 'axios';

import { baseUrlMapper, apiKeyMapper } from './const';
import {
  getBaseParams,
  safeGet,
  getPageLoadTime,
} from './utils';

const apiInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    apiKey: apiKeyMapper[process.env.NODE_ENV],
  },
});

class DeviceFingerprintManager {
  // 发送埋点
  async send(params) {
    try {
      // 字段名解释：https://confluence.ronhan.com/confluence/pages/viewpage.action?pageId=43035843
      const param = {
        ...params,
        ...getBaseParams(),
        plt: safeGet(() => getPageLoadTime()),
      };

      try {
        apiInstance.post(baseUrlMapper[process.env.NODE_ENV] + '/risk-engine/ec/ckt/v1/ublog', param);
      } catch (error) {

      }
    } catch (error) {

    }
  }
}

const deviceFingerprintManager = new DeviceFingerprintManager();

export { deviceFingerprintManager };
